import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 rounded-2xl p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{appData.title}</h2>
              <p className="mt-3 text-sm text-foreground-500">{appData.subtitle}</p>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{appData.description}</p>
              <ul className="mt-5 space-y-2">
                {appData.features.map((feat, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 bg-white rounded-2xl p-3 shadow-sm">
                <img
                  src={appData.qrCodeUrl}
                  alt="吃瓜网51微信公众号二维码"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="mt-3 text-xs text-foreground-400 text-center">微信扫码关注</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}